/* grid-primary-bar.css */
.header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: var(--accent-color);
  }
  
  .title-section {
    flex: 1;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
   
  }

  .title {
    font-weight: 900;
  }

  .subtitle {
    display: flex;
    flex-direction: row;
  }

  .lock-icon {
    margin-top: -6px;
    margin-left: -4px;
  }

  .status-icon {
    height: 16px;
    margin-left: var(--spacing-03);
  }
  
  .button-section {
    display: flex;
    gap: var(--spacing-03);
    align-items: center;
    padding-right: var(--spacing-05);
    padding-top: var(--spacing-03);
    padding-bottom: var(--spacing-03);
  }
